import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  tariffList: []
};

export default {
  namespaced:true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/tariff/index.js